import { acceptInvitationEpic } from './acceptInvitationEpic';
import { confirmInvitationEpic } from './confirmInvitationEpic';
import { createInvitationEpic } from './createInvitationEpic';
import deactivateUserEpic from './deactivateUserEpic';
import { deleteInvitationEpic } from './deleteInvitationEpic';
import fetchRequestedUserDetailsEpic from './fetchRequestedUserDetailsEpic';
import getDeactivatedUsersEpic from './getDeactivatedUsersEpic';
import { getInvitedUsersForLogisticsPartyEpic } from './getInvitedUsersForLogisticsPartyEpic';
import { getUserProfileInfoEpic } from './getUserProfileInfoEpic';
import { getUsersForLogisticsPartyEpic } from './getUsersForLogisticsPartyEpic';
import { resendInvitationEpic } from './resendInvitationEpic';
import { updateUserLocaleEpic } from './updateUserLocaleEpic';
import { updateUserProfileInfoEpic } from './updateUserProfileInfoEpic';

export const userManagementEpics = [
  getUserProfileInfoEpic,
  updateUserProfileInfoEpic,
  acceptInvitationEpic,
  confirmInvitationEpic,
  createInvitationEpic,
  deleteInvitationEpic,
  getInvitedUsersForLogisticsPartyEpic,
  getUsersForLogisticsPartyEpic,
  resendInvitationEpic,
  updateUserLocaleEpic,
  getDeactivatedUsersEpic,
  deactivateUserEpic,
  fetchRequestedUserDetailsEpic,
];

export default userManagementEpics;
